import type {
  PlaycastMessage,
  PlaycastMessageScreenshotCapture,
  PlaycastMessageScreenshotClear,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'process' as const;

export const captureScreenshot = (
  hostId: string,
  sessionName: string,
  width: number,
  height: number,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageScreenshotCapture> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageScreenshotCapture = {
    target,
    action: 'screenshotCapture',
    isReply: false,
    message: { sessionName, width, height },
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageScreenshotCapture>;
};

export const clearScreenshotSession = (
  hostId: string,
  sessionName: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageScreenshotClear> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageScreenshotClear = {
    target,
    action: 'screenshotClear',
    isReply: false,
    message: { sessionName },
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageScreenshotClear>;
};
